const SkipSize = () => {
  return (
    <select name="skip-size" defaultValue="none">
      <option value="none">Skip Size</option>
      <option value="4yd">4yd 35 bin bags approx</option>
      <option value="6yd">6yd 60 - 70 bin bags approx</option>
      <option value="3yd">8yd 75 - 85 bin bags approx</option>
      <option value="3yd">12yd 140 - 160 bin bags approx</option>
      <option value="3yd">16yd 190-210 bin bags approx</option>
      <option value="3yd">20yd for industrial and trade use</option>
      <option value="3yd">40yd for industrial and trade use</option>
    </select>
  );
};

export default SkipSize;
